<div class="logo-wrapper">
    <img [src]="clientLogoUrl">
</div>
<div *ngFor="let language of languages" class="language-btn-wrapper" (click)="selectLanguage(language)">
    {{language.name}}
</div>